import PageWrapper from "../../components/PageWrapper";
import React, { useEffect, useState } from "react";
import { STATIC_STRINGS } from "@asez/shared";
import { SpinnerButton } from "@asez/component-library";
import { SIZES,INPUT_VARIANTS, USER_STATUS } from "@asez/shared";
import RenderTable from "./partials/renderTable";
import RenderLoading from "./partials/renderLoading";
import { GenericInput } from "@asez/component-library";
import useDataFetch, { DataFetchOptionsType } from "../../hooks/useDataFetch";
import { getTableData } from "./services";
import RenderError from "./partials/RenderError";
import { USER_ROLES } from "@asez/shared";

function Settings() {
  const [name , setName] = useState("");
  const [email , setEmail] = useState("");
  const [roleType, setRoleType] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [memberSearch , setMemberSearch] =  useState("");

  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  const { loading, data, error } = useDataFetch(getTableData, fetchOptions);

  useEffect(() => {
    setFetchOptions({ requestId: new Date().getTime().toString() });
  }, []);

  if (loading) {
    return <RenderLoading />;
  }
  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  if(data) {
    return (
      <PageWrapper>
          <div className="card h-full">
            <h1 className="text-2xl font-bold mb-2">{STATIC_STRINGS.SETTINGS_PAGE_HEADER}</h1>
            <div className="flex justify-start gap-2">
              <GenericInput
                type="text"
                label=""
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={STATIC_STRINGS.SETING_PAGE_NAME_PLACEHOLDER}
                className="flex w-1/5"
              />
              <GenericInput
                type="text"
                label=""
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={STATIC_STRINGS.SETING_PAGE_EMAIL_PLACEHOLDER}
                className="flex w-1/5"
              />
              <GenericInput
                type="text"
                placeholder={STATIC_STRINGS.SETTINGS_PAGE_ROLE_TYPE}
                value={roleType}
                onChange={(e) => setRoleType(e.target.value)}
                isSelect
                options={[
                  { label: USER_ROLES.ADMIN, value: USER_ROLES.ADMIN },
                  { label: USER_ROLES.VIEWER, value: USER_ROLES.VIEWER },
                  { label:USER_ROLES.EDITOR, value:USER_ROLES.EDITOR },
                ]}
                className="w-1/5"
                sx={{ flex: 1 }}
              />
              <GenericInput
                type="text"
                placeholder={STATIC_STRINGS.SETTINGS_PAGE_USER_STATUS}
                value={userStatus}
                onChange={(e) => setUserStatus(e.target.value)}
                isSelect
                options={[
                  { label: USER_STATUS.INVITED, value: USER_STATUS.INVITED },
                  { label: USER_STATUS.JOINED, value: USER_STATUS.JOINED },
                ]}
                className="w-1/5"
                sx={{ flex: 1 }}
              />
              
              <div className="flex-1">Timestamp here</div>
            </div>
            <div className="mt-4 mb-4">
              <SpinnerButton loading={false} onClickHandler={() => {}} className="w-56" size={SIZES.sm}>
                {STATIC_STRINGS.SETTINGS_PAGE_INVITE_MEMBER}
              </SpinnerButton>
            </div>
            <div className="max-w-[1302px] xl:card py-3 m-auto">
              <div className="mb-4">
                <GenericInput
                  placeholder={STATIC_STRINGS.SETTINGS_PAGE_MEMBER_SEARCH}
                  type="text"
                  value={memberSearch}
                  variant={INPUT_VARIANTS.outlined}
                  size={SIZES.sm}
                  className="w-1/3 py-2"
                  onChange={(e) => setMemberSearch(e.target.value)}
                />
              </div>
              <RenderTable data={data} searchTerm={memberSearch} />
            </div>
          </div>
      </PageWrapper>
    );
  }
}

export default Settings;
